module.exports = __WEBPACK_EXTERNAL_MODULE_0__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"@pakhshkit-js/pakhshkit-js","commonjs2":"@pakhshkit-js/pakhshkit-js","amd":"pakhshkit-js","root":["pakhshkit","core"]}
// module id = 0
// module chunks = 0


// WEBPACK FOOTER //
// dash/external {"commonjs":"@pakhshkit-js/pakhshkit-js","commonjs2":"@pakhshkit-js/pakhshkit-js","amd":"pakhshkit-js","root":["pakhshkit","core"]}